// retrieve meta tag content value by name
const metaContent = (name) => {
  const element = document.head.querySelector(`meta[name="${name}"]`);
  return element && element.content;
};

export default metaContent;
